import { itemApi } from "@api/items";
import { Error } from "@components/Error";
import { Loader } from "@components/Loader";
import { ResultsTable } from "@components/ResultsTable/ResultsTable";
import { goTo } from "@history";
import { NewButton } from "@components/backoffice/buttons/NewButton";
import { BackOfficeRoutes } from "@routes/urls";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button } from "semantic-ui-react";
import { DeleteRecordModal } from "@components/backoffice/DeleteRecordModal";
import { AuditService } from "@api/audit/audit";
import { userApi } from "@api/users/user";

export default class InternalLocationList extends Component {
  componentDidMount() {
    const { fetchInternalLocations } = this.props;
    fetchInternalLocations();
  }

  handleOnRefClick(itemPid) {
    goTo(BackOfficeRoutes.itemEditFor(itemPid));
  }

  createRefProps(ilocPid) {
    return [
      {
        refType: "Item",
        onRefClick: this.handleOnRefClick,
        getRefData: () => itemApi.list(`internal_location_pid:${ilocPid}`),
      },
    ];
  }

  handleDeleteWithAudit = async (ilocPid) => {
    const { deleteInternalLocation } = this.props;

    try {
      // Fetch user identity for audit trail
      const userRes = await userApi.get();
      const userData = userRes.data;
      const userName =
        userData?.full_name ||
        userData?.username ||
        userData?.email ||
        "Unknown User";

      // Perform deletion
      await deleteInternalLocation(ilocPid);

      // Log audit entry
      await AuditService.api.createLog({
        action: "Delete Internal Location",
        details: `User ${userName} deleted Internal Location with ID ${ilocPid}.`,
        created_by: userName,
      });
    } catch (error) {
      console.error("Audit logging or deletion failed:", error);
      throw error; // allow DeleteRecordModal to handle/display the error if necessary
    }
  };

  rowActions = ({ row }) => {
    return (
      <>
        <Button
          as={Link}
          to={BackOfficeRoutes.ilocationsEditFor(row.metadata.pid)}
          icon="edit"
          size="small"
          title="Edit Record"
        />
        <DeleteRecordModal
          refProps={this.createRefProps(row.metadata.pid)}
          onDelete={() => this.handleDeleteWithAudit(row.metadata.pid)}
          deleteHeader={`Are you sure you want to delete the Internal Location
  record with ID ${row.metadata.pid}?`}
        />
      </>
    );
  };

  renderResults(data) {
    const headerActionComponent = (
      <NewButton
        text="New internal location"
        to={BackOfficeRoutes.ilocationsCreate}
      />
    );

    const columns = [
      { title: "ID", field: "metadata.pid" },
      { title: "Location", field: "metadata.location.name" },
      { title: "Name", field: "metadata.name" },
      { title: "Physical location", field: "metadata.physical_location" },
      { title: "Location e-mail", field: "metadata.location.email" },
      { title: "Actions", field: "", formatter: this.rowActions },
    ];

    return (
      <ResultsTable
        data={data.hits}
        columns={columns}
        totalHitsCount={data.total}
        showAllResults
        title="Internal Locations"
        name="internal locations"
        headerActionComponent={headerActionComponent}
      />
    );
  }

  render() {
    let { data, error, isLoading } = this.props;
    return (
      <Loader isLoading={isLoading}>
        <Error error={error}>{this.renderResults(data)}</Error>
      </Loader>
    );
  }
}

InternalLocationList.propTypes = {
  data: PropTypes.object.isRequired,
  fetchInternalLocations: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.object,
  deleteInternalLocation: PropTypes.func.isRequired,
};

InternalLocationList.defaultProps = {
  error: null,
};
